import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton } from '@material-ui/core';
import { includes } from 'lodash';
import matchSorter from 'match-sorter';

import { ClientDepartment } from 'api';
import { DeleteIcon, Suggest, ISuggestProps } from 'components';
import { SuggestionTypeObject } from './Suggest/types';

interface IProps extends Partial<ISuggestProps> {
  departments: ClientDepartment[];
}

const AddDepartment: FC<IProps> = ({ exclusions, departments, onChange, ...rest }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  const excluded = departments.filter(({ id }) => !includes(exclusions, id));
  const sorted = matchSorter(excluded, value, { keys: ['title'] }) as SuggestionTypeObject[];

  return (
    <Grid container alignItems="center">
      <Grid item xs>
        <Suggest
          type="department"
          inputValue={value}
          placeholder={t('components:departmentSuggest')}
          suggestions={!!value.length ? sorted : []}
          onChange={onChange}
          onInputChange={inputValue => setValue(inputValue)}
          {...rest}
        />
      </Grid>
      {!!value.length && (
        <Grid item>
          <IconButton onClick={() => setValue('')}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default AddDepartment;
